<template>
  <vs-popup :active.sync="showPopup" :title="popupTitle">{{popupContent}}</vs-popup>
</template>

<script>
export default {
  data() {
    return {
      showPopup: false,
      popupTitle: "Thông báo",
      popupContent: "dasdadasdas"
    }
  },
  watch: {
  },
  created() {
    if (JSON.parse(localStorage.userInfo).userRole != "admin") {
      this.$business.post('/user-package/using-package').then((response) => {
        this.$vs.loading.close();
        if (response.data.length == 0) {
          // this.showPopup = true;
          this.$business.post('/user-package/active-trial-package').then((response) => {
            if (response.data.length == 0) {
              this.showPopup = true;

            }
          })
        }
      }).catch(() => {
        this.showPopup = false;
        this.$vs.loading.close();
      });
    }
  },
  methods: {
  }
}
</script>
